module.exports = __webpack_public_path__ + "static/index/img/baikal-705.85cd61db.jpg";